import React from 'react';
import { useTranslation } from 'react-i18next';
import StudentHatIcon from '../../assets/student-hat-icon.svg';
import css from './TrainingRequestWidget.module.scss';

export const TrainingRequestWidget: React.FC = () => {
    const { t } = useTranslation('TrainingRequests');

    return (
        <>
            <div className={css.middleContainer}>
                <div className={css.icon}>
                    <StudentHatIcon />
                </div>
                <div>
                    {t(
                        'Receive hands-on training with heavy equipment and jobsite skills from industry professionals.',
                    )}
                </div>
                <div>{t('Reach out to one of our training specialists today.')}</div>
            </div>
        </>
    );
};
